import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'

// Lightweight viewer query — distinct from the full CLIENT_DATA_QUERY in
// graphql/queries.js. Used by components that only need the client id +
// account ids and the banner-gating flag (PT-5333).
//
// `requiresLegalConfirmation` is set by Eagle API during partner-API
// registration and cleared by the confirmPartnerLegalAcceptance mutation
// once the client confirms the Solicitation Acceptance banner.
const VIEWER = gql`
  query {
    viewer {
      ... on Client {
        accounts {
          ... on BaseAccount {
            id
          }
        }
        id
        requiresLegalConfirmation
      }
    }
  }
`
export const useViewer = () => {
  const {loading, data} = useQuery(VIEWER)

  const viewer = data?.viewer

  return {
    loading,
    viewer,
  }
}
